const DEFAULT_CHAT_VALUES = {
  name: "New chat",
  icon: "message"
}

const QA_STATES = {
  CANCELED: -1,
  IDLE: 0,
  LOADING: 1,
  DONE: 2
}

const MIN_REPS = 1;
const MAX_REPS = 4;
// const MIN_PROUTS = 1;
// const MAX_PROUTS = 30;
const MIN_DELAY = 1;
const MAX_DELAY = 3;
// const MAX_LEN = 30;

const COOL_PROUT_LINKS = [
  "Flatulence",
  "Pétomane",
  "Pet_vaginal",
  "Chien",
  "Chat",
  "baleine",
  "vagin_humain",
  "pénis",
]

const COOL_PROUT_REPLACEMENTS_PROPER_NOUNS = [
  "homme",
  "femme",
  "femelle",
  "génital",
  "génitaux",
  "clitoris",
  "baleine",
  "canard",
  "serpent",
  "chat",
  "enfant",
  "chien",
  "mari",
  "moine",
  "nonne",
  "animaux",
  "mâle",
  "lapin",
  "canin",
  "loup",
  "cétacé",
  "humain",
]

const COOL_PROUT_REPLACEMENTS_NOUNS = [
  "pénis",
  "urètre",
  "éjacul",
  "frein",
  "cul",
  "gynéc",
  "orgasme",
  "sperm",
  "vagin",
  "ventre",
  "Mr.",
  "Dr.",
  "sources",
  "wikimedia",
  "jour",
  "mode",
  "testicule",
  "bite",
  "sex",
  "travail",
  "seins",
  "ovule",
  "chromozome",
  "gland",
  "testicul",
]

const COOL_PROUT_REPLACEMENTS_ADJECTIVES = [
  "jeune",
  "joli",
  "chaud",
  "compliqué",
  "cool",
  "étrange",
  "courageux",
  "difficile",
  "drôle",
  "faible",
  "fragile",
  "froid",
  "gentil",
  "grand",
  "grave",
  "gros",
  "heureux",
  "humide",
  "intelligent",
  "intéresant",
  "jaloux",
  "joyeux",
  "large",
  "lent",
  "libre",
  "long",
  "lourd",
  "masculin",
  "féminin",
  "article",
  "note",
]

const COOL_PROUT_REPLACEMENTS_VERBS = [
  "être",
  "faire",
  "aller",
  "venir",
  "devoir",
  "manger",
  "dessiner",
  "lubrifier"
]


//THX: https://stackoverflow.com/questions/46219537/replace-all-occurrence-of-specific-words-in-a-sentence-based-on-an-array-of-word
const REG_NOUNS = new RegExp(`\\b(${COOL_PROUT_REPLACEMENTS_NOUNS.join('|')})`, 'gi');
const REG_VERBS = new RegExp(`\\b(${COOL_PROUT_REPLACEMENTS_VERBS.join('|')})`, 'gi');
const REG_ADJECTIVES = new RegExp(`\\b(${COOL_PROUT_REPLACEMENTS_ADJECTIVES.join('|')}\\b)`, 'gi');
const REG_PROPER_NOUNS = new RegExp(`\\b(${COOL_PROUT_REPLACEMENTS_PROPER_NOUNS.join('|')}\\b)`, 'gi');



const PROUT = "rout";

const QA_QUESTION_INVALID = "Je n'ai pas bien compris votre question. Pouvez vous essayer d'y inclure le mot \"prout\" 💨?"

class QA {

  constructor(question) {
    this.question = question;
    this.answer = "";
    this.state = QA_STATES.IDLE
  }

  cancel() {
    this.state = QA_STATES.CANCELED;
  }

  retry() {
    this.answer = "";
    this.retry();
  }

  async fetchAnswer() {
    if (this.question.toLowerCase().includes("prout")) {
      this.state = QA_STATES.LOADING
      const facts = await QA.fetchFartFacts();
      for (let i = 0; i < facts.length; i++) {
        if (this.state === QA_STATES.CANCELED) {
          break;
        }
        this.answer += " " + facts[i].replace(REG_NOUNS, "prout").replace(REG_VERBS, "prouter").replace(REG_ADJECTIVES, "proutesque").replace(REG_PROPER_NOUNS, QA.getRandomInt(0, 1) ? "prouteuse" : "prouteur");
        await QA.sleep(QA.getRandomInt(MIN_DELAY, MAX_DELAY) * 100);

      }
      this.answer += " 💨."
      this.state = QA_STATES.DONE
    }else{
      this.answer = QA_QUESTION_INVALID;
    }
  }

  static async fetchFartFacts() {
    const res = await fetch(`https://fr.wikipedia.org/api/rest_v1/page/html/${COOL_PROUT_LINKS[QA.getRandomInt(0,COOL_PROUT_LINKS.length-1)]}`, {
      method: 'GET'
    })
    const json = await res.text();
    const parser = new DOMParser();
    const htmlDoc = parser.parseFromString(json, 'text/html');
    const sections = htmlDoc.getElementsByTagName("p");
    const filteredSections = [];
    for (let i = 0; i < sections.length; i++) {
      if (sections[i].className == "") {
        filteredSections.push(sections[i]);
      }
    }
    if (filteredSections && filteredSections.length) {
      return filteredSections[QA.getRandomInt(0, filteredSections.length - 1)].innerText.split(" ");
    }
    return ["Proutus", "Fartus", "Flatus 💨."]
  }

  static async genFart() {
    let fart = "p" + PROUT.split("").map(c => {
      return c.repeat(QA.getRandomInt(MIN_REPS, MAX_REPS));
    }).join("");
    return fart
  }

  static getRandomInt(min, max) {
    min = Math.ceil(min);
    max = Math.floor(max);
    return Math.floor(Math.random() * (max - min + 1)) + min;
  }

  static sleep(ms) {
    return new Promise(resolve => {
      setTimeout(resolve, ms);
    })
  }

  //THX: https://stackoverflow.com/questions/7033639/split-large-string-in-n-size-chunks-in-javascript
  static chunkString(str, len) {
    const size = Math.ceil(str.length / len)
    const r = Array(size)
    let offset = 0
    for (let i = 0; i < size; i++) {
      r[i] = str.substr(offset, len)
      offset += len
    }

    return r
  }


}

export default class Chat {

  constructor() {
    this.name = DEFAULT_CHAT_VALUES.name;
    this.icon = DEFAULT_CHAT_VALUES.icon;
    this.conversation = [];
  }

  get currentConversation() {
    return this.conversation[this.conversation.length - 1];
  }

  async ask(question) {
    const qa = new QA(question);
    this.conversation.push(qa);
    return qa;
  }

}